const prefix = "PROVIDER_";

export const AUTOCOMPLETE_FAILED = prefix + "AUTOCOMPLETE_FAILED";
export const AUTOCOMPLETE_STARTED = prefix + "AUTOCOMPLETE_STARTED";
export const AUTOCOMPLETE_SUCCEEDED = prefix + "AUTOCOMPLETE_SUCCEEDED";
export const EXPORT_FAILED = prefix + "EXPORT_FAILED";
export const EXPORT_STARTED = prefix + "EXPORT_STARTED";
export const EXPORT_SUCCEEDED = prefix + "EXPORT_SUCCEEDED";
export const LIST_CLEAR_CRITERIA = prefix + "LIST_CLEAR_CRITERIA";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const LIST_SET_CRITERIA = prefix + "LIST_SET_CRITERIA";
export const LIST_SET_CRITERIA_DESCRIPTION = prefix + "LIST_SET_CRITERIA_DESCRIPTION";
export const LIST_SET_PAGING = prefix + "LIST_SET_PAGING";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const RISK_PROFILE_HELP_FAILED = prefix + "RISK_PROFILE_HELP_FAILED";
export const RISK_PROFILE_HELP_STARTED = prefix + "RISK_PROFILE_HELP_STARTED";
export const RISK_PROFILE_HELP_SUCCEEDED = prefix + "RISK_PROFILE_HELP_SUCCEEDED";
export const RISK_PROFILE_VSL_FAILED = prefix + "RISK_PROFILE_VSL_FAILED";
export const RISK_PROFILE_VSL_STARTED = prefix + "RISK_PROFILE_VSL_STARTED";
export const RISK_PROFILE_VSL_SUCCEEDED = prefix + "RISK_PROFILE_VSL_SUCCEEDED";
export const RISK_PROFILE_UPFRONT_FAILED = prefix + "RISK_PROFILE_UPFRONT_FAILED";
export const RISK_PROFILE_UPFRONT_STARTED = prefix + "RISK_PROFILE_UPFRONT_STARTED";
export const RISK_PROFILE_UPFRONT_SUCCEEDED = prefix + "RISK_PROFILE_UPFRONT_SUCCEEDED";
export const SAP_TEST_BLANK = prefix + "SAP_TEST_BLANK";
export const SAP_TEST_READING_FAILED = prefix + "SAP_TEST_READING_FAILED";
export const SAP_TEST_READING_STARTED = prefix + "SAP_TEST_READING_STARTED";
export const SAP_TEST_READING_SUCCEEDED = prefix + "SAP_TEST_READING_SUCCEEDED";
export const SAP_TEST_WRITING_FAILED = prefix + "SAP_TEST_WRITING_FAILED";
export const SAP_TEST_WRITING_STARTED = prefix + "SAP_TEST_WRITING_STARTED";
export const SAP_TEST_WRITING_SUCCEEDED = prefix + "SAP_TEST_WRITING_SUCCEEDED";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const VIEW_CLEAR = prefix + "VIEW_CLEAR";
export const VIEW_FAILED = prefix + "VIEW_FAILED";
export const VIEW_NEXT = prefix + "VIEW_NEXT";
export const VIEW_PREVIOUS = prefix + "VIEW_PREVIOUS";
export const VIEW_STARTED = prefix + "VIEW_STARTED";
export const VIEW_SUCCEEDED = prefix + "VIEW_SUCCEEDED";
